<template>
  <div id="app">
    <Navbar />

    <main class="main-content">
      <router-view />
    </main>
  </div>
</template>

<script>
// Navbar만 공통 컴포넌트로 가져옵니다.
import HaimNavbar from './components/HaimNavbar.vue'

export default {
  name: 'App',
  components: {
    Navbar: HaimNavbar
  }
}
</script>

<style>
/* 전역 스타일 설정 */
body {
  background-color: #f8f9fa;
  margin: 0;
  padding: 0;
  font-family: 'Noto Sans KR', sans-serif;
}

/* 네비바 아래에 적절한 여백 확보 */
.main-content {
  min-height: calc(100vh - 70px);
}

/* 타임피커 높이를 입력창과 맞추기 */
.jinro-timepicker {
  height: 35px;
  border-radius: 8px;
  border: 1px solid #f0f0f0;
  background-color: #f9f9f9;
  font-size: 0.85rem;
}

/* 타임피커 내부 버튼 간격 조정 */
.jinro-timepicker >>> .btn {
  padding: 0 0.5rem;
}
/* [인쇄 핵심 설정]
   인쇄 유틸리티(invoicePrint.js)가 작동할 때 화면상의 요소를 숨기기 위해 유지합니다. */
@media print {
  #print-area {
    display: block !important; /* 인쇄할 때만 보이게 강제 */
  }
  /* 화면상의 모든 요소 숨기기 */
  body * {
    visibility: hidden;
  }
  /* 인쇄할 영역만 보이게 하기 */
  #real-print-content, #real-print-content * {
    visibility: visible;
  }
  #real-print-content {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
  }
  /* 테이블 선 강제 출력 */
  table { border: 1px solid black !important; }
  th, td { border: 1px solid black !important; }
}

/* 공통 와이드 레이아웃 클래스 */
.layout-wide {
  width: 94% !important; /* 전체 화면의 94%만 사용 (좌우 3%씩 여백) */
  max-width: 1800px !important; /* 너무 큰 모니터에서는 1800px로 제한 */
  margin: 0 auto !important; /* 중앙 정렬 */
  padding-left: 15px;
  padding-right: 15px;
}
</style>
